import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { toast } from "sonner";
import { AuthShell } from "../components/AuthShell";
import { publicApi, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const { logout } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) return setErr("Passwords don't match.");
    setBusy(true);
    setErr("");
    try {
      await publicApi.post("/auth/reset-password", { token, password: pw });
      logout();
      toast.success("Password updated! Log in with your new password.");
      nav("/login");
    } catch (e2) {
      const tokenBad = e2?.response?.status === 422 && JSON.stringify(e2.response.data?.detail || "").includes("token");
      setErr(tokenBad ? "This link is invalid or has expired. Please request a new one." : errMsg(e2));
    } finally { setBusy(false); }
  };

  if (!token) {
    return (
      <AuthShell testid="reset-missing-token">
        <h1 className="text-3xl font-bold">Link not valid</h1>
        <p>This reset link is missing its code. Please request a new one.</p>
        <Link to="/forgot-password" className="zn-btn bg-[#FFD23F] w-full">Request a new link</Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell testid="reset-form-card">
      <KeyRound size={40} />
      <h1 className="text-3xl sm:text-4xl font-bold">Choose a new password</h1>
      <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
        <input data-testid="reset-password-input" type="password" autoComplete="new-password" className="zn-input" placeholder="New password (8+ characters)" minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} required />
        <input data-testid="reset-password-confirm-input" type="password" autoComplete="new-password" className="zn-input" placeholder="Type it again" minLength={8} value={pw2} onChange={(e) => setPw2(e.target.value)} required />
        {err && <p data-testid="reset-error" className="text-[#E8442A] font-semibold text-sm">{err}</p>}
        <button data-testid="reset-submit-btn" disabled={busy} className="zn-btn bg-[#7B5CFA] text-white w-full text-lg">{busy ? "Saving…" : "Save new password"}</button>
      </form>
      <p className="text-xs text-[#1B1A2E]/60">For safety, you'll be signed out on all other devices.</p>
      {err && <Link to="/forgot-password" data-testid="reset-request-new" className="block text-sm font-bold underline text-center">Request a new link</Link>}
    </AuthShell>
  );
}
